/**
 * COMPREHENSIVE SEO DATA FOR ALL ROUTES
 * Generated with unique Title, Description, H1 for EN/ES/VI
 */

export interface PageSEOData {
  title: string;
  description: string;
  h1: string;
  keywords?: string;
}

export interface SEODataByLanguage {
  en: PageSEOData;
  es: PageSEOData;
  vi: PageSEOData;
}

// Master SEO mapping for ALL routes
export const comprehensiveSEOData: Record<string, SEODataByLanguage> = {
  '/': {
    en: {
      title: 'Houston Immigration Attorneys | Daniel Albert Law | Visas, Green Cards & More',
      description: 'Experienced immigration attorneys in Houston help clients with visas, green cards, citizenship, deportation defense, asylum, and other legal matters. Schedule a consultation today.',
      h1: 'Houston Immigration Lawyers',
      keywords: 'immigration lawyer Houston, Houston immigration attorney, asylum lawyer Houston'
    },
    es: {
      title: 'Abogados de Inmigración en Houston | Daniel Albert Law | Visas, Residencia y Más',
      description: 'Abogados de inmigración experimentados en Houston ayudan con visas, tarjetas verdes, ciudadanía, defensa contra deportación, asilo y otros asuntos legales. Programe una consulta hoy.',
      h1: 'Abogados de Inmigración en Houston',
      keywords: 'abogado de inmigración Houston, abogado de asilo Houston'
    },
    vi: {
      title: 'Luật Sư Di Trú Houston | Daniel Albert Law | Thị thực, Thẻ xanh & Hơn Thế Nữa',
      description: 'Luật sư di trú giàu kinh nghiệm tại Houston hỗ trợ xin thị thực, thẻ xanh, nhập tịch, bảo vệ trục xuất, tị nạn và các vấn đề pháp lý khác. Đặt lịch hẹn ngay hôm nay.',
      h1: 'Luật Sư Di Trú Houston',
      keywords: 'luật sư di trú Houston, luật sư tị nạn Houston'
    }
  },

  '/about-us': {
    en: {
      title: 'About Us - Houston Immigration & Legal Firm',
      description: 'Meet Daniel Albert and our experienced legal team. Over 20 years serving Houston with immigration, family law, and comprehensive legal services.',
      h1: 'About Daniel Albert Law Firm'
    },
    es: {
      title: 'Sobre Nosotros - Firma Legal de Inmigración Houston',
      description: 'Conozca a Daniel Albert y nuestro equipo legal experimentado. Más de 20 años sirviendo a Houston con inmigración y servicios legales completos.',
      h1: 'Sobre la Firma Daniel Albert Law'
    },
    vi: {
      title: 'Về Chúng Tôi - Công Ty Luật Di Trú Houston',
      description: 'Gặp gỡ Daniel Albert và đội ngũ luật sư giàu kinh nghiệm. Hơn 20 năm phục vụ Houston với di trú và dịch vụ pháp lý toàn diện.',
      h1: 'Về Công Ty Luật Daniel Albert'
    }
  },

  '/practice-areas': {
    en: {
      title: 'Practice Areas | Daniel Albert Law',
      description: 'Explore the diverse practice areas handled by Daniel Albert Law, including immigration, criminal defense, family law, personal injury, real estate, business, probate and tax.',
      h1: 'Our Practice Areas'
    },
    es: {
      title: 'Áreas de Práctica | Daniel Albert Law',
      description: 'Explore las diversas áreas de práctica de Daniel Albert Law: inmigración, defensa penal, derecho familiar, lesiones personales, bienes raíces, negocios, sucesiones e impuestos.',
      h1: 'Nuestras Áreas de Práctica'
    },
    vi: {
      title: 'Các Lĩnh Vực Hành Nghề | Daniel Albert Law',
      description: 'Khám phá các lĩnh vực hành nghề của Daniel Albert Law bao gồm di trú, bào chữa hình sự, luật gia đình, thương tích cá nhân, bất động sản, doanh nghiệp, di chúc và thuế.',
      h1: 'Các Lĩnh Vực Hành Nghề'
    }
  },

  '/contact': {
    en: {
      title: 'Contact Daniel Albert Law | Schedule Your Consultation',
      description: 'Contact our Houston law firm to discuss your immigration, criminal defense, family law, personal injury or business law needs. Schedule a confidential consultation with an attorney.',
      h1: 'Contact Us'
    },
    es: {
      title: 'Contacto Daniel Albert Law | Programe Su Consulta',
      description: 'Contáctenos para hablar sobre sus necesidades de inmigración, defensa penal, derecho familiar, lesiones personales o negocios. Programe una consulta confidencial con un abogado.',
      h1: 'Contáctenos'
    },
    vi: {
      title: 'Liên Hệ Daniel Albert Law | Đặt Lịch Tư Vấn',
      description: 'Liên hệ với văn phòng luật của chúng tôi tại Houston để thảo luận về nhu cầu di trú, bào chữa hình sự, luật gia đình, thương tích cá nhân hoặc luật doanh nghiệp của bạn. Đặt lịch tư vấn bí mật cùng luật sư.',
      h1: 'Liên Hệ'
    }
  },

  '/appointment': {
    en: {
      title: 'Free Consultation | Daniel Albert Law',
      description: 'Schedule a free consultation with Daniel Albert Law Firm to discuss your case. Our attorneys are ready to evaluate your situation and explain your legal options.',
      h1: 'Schedule a Consultation'
    },
    es: {
      title: 'Consulta Gratuita | Daniel Albert Law',
      description: 'Programe una consulta gratuita con Daniel Albert Law para discutir su caso. Nuestros abogados están listos para evaluar su situación y explicar sus opciones legales.',
      h1: 'Programar una Consulta'
    },
    vi: {
      title: 'Tư Vấn Miễn Phí | Daniel Albert Law',
      description: 'Đặt lịch tư vấn miễn phí với Daniel Albert Law để thảo luận về vụ việc của bạn. Các luật sư của chúng tôi sẵn sàng đánh giá tình huống và giải thích các lựa chọn pháp lý.',
      h1: 'Đặt Lịch Tư Vấn'
    }
  },

  '/blog': {
    en: {
      title: 'Immigration Law Blog - Houston Legal Updates & Guides',
      description: 'Immigration law insights, legal guides, and updates from Houston immigration lawyer Daniel Albert. Stay informed on the latest immigration news.',
      h1: 'Legal Resources & Blog'
    },
    es: {
      title: 'Blog de Derecho de Inmigración - Actualizaciones Legales Houston',
      description: 'Perspectivas expertas sobre derecho de inmigración, guías legales y actualizaciones del abogado Daniel Albert en Houston.',
      h1: 'Recursos Legales y Blog'
    },
    vi: {
      title: 'Blog Luật Di Trú - Cập Nhật Pháp Lý Houston',
      description: 'Thông tin chuyên sâu về luật di trú, hướng dẫn pháp lý và cập nhật từ luật sư Daniel Albert tại Houston.',
      h1: 'Tài Nguyên Pháp Lý & Blog'
    }
  },

  '/practice-areas/immigration-services': {
    en: {
      title: 'Immigration Lawyer Houston - Visa, Green Card, Citizenship',
      description: 'Comprehensive immigration services in Houston: Family & employment visas, green cards, citizenship, asylum, deportation defense. Trilingual attorney.',
      h1: 'Immigration Services in Houston'
    },
    es: {
      title: 'Abogado Inmigración Houston - Visa, Tarjeta Verde, Ciudadanía',
      description: 'Servicios completos de inmigración en Houston: Visas familiares y laborales, tarjetas verdes, ciudadanía, asilo, defensa contra deportación.',
      h1: 'Servicios de Inmigración en Houston'
    },
    vi: {
      title: 'Luật Sư Di Trú Houston - Visa, Thẻ Xanh, Quốc Tịch',
      description: 'Dịch vụ di trú toàn diện tại Houston: Visa gia đình và lao động, thẻ xanh, quốc tịch, tị nạn, phòng thủ trục xuất.',
      h1: 'Dịch Vụ Di Trú tại Houston'
    }
  },

  '/practice-areas/immigration-services/asylum-in-the-united-states': {
    en: {
      title: 'Asylum Lawyer Houston - Protection from Persecution',
      description: 'Asylum services in Houston. Skilled representation for persecution victims. Affirmative & defensive asylum cases. Call (832) 930-3059.',
      h1: 'Asylum Services'
    },
    es: {
      title: 'Abogado de Asilo Houston - Protección Contra Persecución',
      description: 'Servicios de asilo en Houston. Representación experta para víctimas de persecución. Casos de asilo afirmativo y defensivo.',
      h1: 'Servicios de Asilo'
    },
    vi: {
      title: 'Luật Sư Tị Nạn Houston - Bảo Vệ Khỏi Bắt Bớ',
      description: 'Dịch vụ tị nạn tại Houston. Đại diện chuyên nghiệp cho nạn nhân bị bắt bớ. Các trường hợp tị nạn khẳng định và phòng thủ.',
      h1: 'Dịch Vụ Tị Nạn'
    }
  },

  '/practice-areas/immigration-services/family-based-immigration': {
    en: {
      title: 'Family Immigration Lawyer Houston - Reunite with Loved Ones',
      description: 'Family-based immigration services in Houston. Spouse visas, K-1 fiancé visas, parent & children petitions. Experienced immigration attorney.',
      h1: 'Family-Based Immigration'
    },
    es: {
      title: 'Abogado Inmigración Familiar Houston - Reúnase con Seres Queridos',
      description: 'Servicios de inmigración familiar en Houston. Visas de cónyuge, visas K-1 de prometido, peticiones de padres e hijos.',
      h1: 'Inmigración Basada en Familia'
    },
    vi: {
      title: 'Luật Sư Di Trú Gia Đình Houston - Đoàn Tụ Với Người Thân',
      description: 'Dịch vụ di trú gia đình tại Houston. Visa vợ/chồng, visa hôn phu K-1, đơn xin cha mẹ và con cái.',
      h1: 'Di Trú Theo Diện Gia Đình'
    }
  },

  '/practice-areas/criminal-defense': {
    en: {
      title: 'Criminal Defense Lawyer Houston - Aggressive Legal Representation',
      description: 'Experienced criminal defense attorney in Houston. DWI, drug charges, assault, theft. Protect your rights and freedom. Call (832) 930-3059.',
      h1: 'Criminal Defense Services'
    },
    es: {
      title: 'Abogado Defensa Criminal Houston - Representación Legal Agresiva',
      description: 'Abogado experimentado de defensa criminal en Houston. DWI, cargos de drogas, asalto, robo. Proteja sus derechos y libertad.',
      h1: 'Servicios de Defensa Criminal'
    },
    vi: {
      title: 'Luật Sư Biện Hộ Hình Sự Houston - Đại Diện Pháp Lý Mạnh Mẽ',
      description: 'Luật sư biện hộ hình sự giàu kinh nghiệm tại Houston. DWI, tội danh ma túy, tấn công, trộm cắp. Bảo vệ quyền và tự do.',
      h1: 'Dịch Vụ Biện Hộ Hình Sự'
    }
  },

  '/practice-areas/criminal-defense/dwi': {
    en: {
      title: 'DWI Lawyer Houston - Drunk Driving Defense Attorney',
      description: 'DWI defense lawyer in Houston. First offense, repeat DWI, felony DWI. Fight drunk driving charges. Protect your license and freedom.',
      h1: 'DWI Defense'
    },
    es: {
      title: 'Abogado DWI Houston - Defensa por Conducir Ebrio',
      description: 'Abogado de defensa DWI en Houston. Primera ofensa, DWI repetido, DWI con delito grave. Proteja su licencia y libertad.',
      h1: 'Defensa DWI'
    },
    vi: {
      title: 'Luật Sư DWI Houston - Biện Hộ Lái Xe Say Rượu',
      description: 'Luật sư biện hộ DWI tại Houston. Vi phạm lần đầu, DWI lặp lại, DWI trọng tội. Bảo vệ bằng lái và tự do của bạn.',
      h1: 'Biện Hộ DWI'
    }
  },

  '/practice-areas/business-law/partnership-agreements': {
    en: {
      title: 'Partnership Agreement Lawyer Houston - Business Law',
      description: 'Comprehensive partnership and operating agreement drafting for Texas businesses. Legally sound agreements defining ownership, management, profit distribution.',
      h1: 'Partnership Agreement Services'
    },
    es: {
      title: 'Abogado Acuerdos de Asociación Houston - Derecho Comercial',
      description: 'Redacción integral de acuerdos de asociación y operación para negocios en Texas. Acuerdos legalmente sólidos que definen propiedad y gestión.',
      h1: 'Servicios de Acuerdos de Asociación'
    },
    vi: {
      title: 'Luật Sư Thỏa Thuận Đối Tác Houston - Luật Kinh Doanh',
      description: 'Soạn thảo thỏa thuận đối tác và vận hành toàn diện cho doanh nghiệp Texas. Thỏa thuận hợp pháp xác định quyền sở hữu và quản lý.',
      h1: 'Dịch Vụ Thỏa Thuận Đối Tác'
    }
  },

  '/practice-areas/business-law/trademark-registration': {
    en: {
      title: 'Trademark Registration Lawyer Houston - Brand Protection',
      description: 'Federal and state trademark registration to protect your brand, logo, and business identity. USPTO filing and intellectual property defense.',
      h1: 'Trademark Registration Services'
    },
    es: {
      title: 'Abogado Registro de Marcas Houston - Protección de Marca',
      description: 'Registro federal y estatal de marcas para proteger su marca, logotipo e identidad comercial. Presentación USPTO y defensa de propiedad intelectual.',
      h1: 'Servicios de Registro de Marcas'
    },
    vi: {
      title: 'Luật Sư Đăng Ký Nhãn Hiệu Houston - Bảo Vệ Thương Hiệu',
      description: 'Đăng ký nhãn hiệu liên bang và tiểu bang để bảo vệ thương hiệu, logo và nhận diện doanh nghiệp của bạn. Nộp hồ sơ USPTO.',
      h1: 'Dịch Vụ Đăng Ký Nhãn Hiệu'
    }
  },

  '/practice-areas/business-law/nonprofit-formation': {
    en: {
      title: 'Nonprofit Formation Lawyer Houston - 501(c)(3) Setup',
      description: 'Complete 501(c)(3) formation and tax-exempt status applications for Texas non-profit organizations. Incorporation, IRS applications, bylaws.',
      h1: 'Non-Profit Organization Formation'
    },
    es: {
      title: 'Abogado Formación de Organización Sin Fines de Lucro Houston',
      description: 'Formación completa 501(c)(3) y solicitudes de estatus exento de impuestos para organizaciones sin fines de lucro de Texas.',
      h1: 'Formación de Organización Sin Fines de Lucro'
    },
    vi: {
      title: 'Luật Sư Thành Lập Tổ Chức Phi Lợi Nhuận Houston - 501(c)(3)',
      description: 'Thành lập 501(c)(3) hoàn chỉnh và đơn xin tình trạng miễn thuế cho tổ chức phi lợi nhuận Texas.',
      h1: 'Thành Lập Tổ Chức Phi Lợi Nhuận'
    }
  },

  '/privacy-policy': {
    en: {
      title: 'Privacy Policy - Daniel Albert Law Firm',
      description: 'Privacy policy for Daniel Albert Law Firm. Learn how we protect your personal information and legal confidentiality.',
      h1: 'Privacy Policy'
    },
    es: {
      title: 'Política de Privacidad - Firma Legal Daniel Albert',
      description: 'Política de privacidad de la Firma Legal Daniel Albert. Aprenda cómo protegemos su información personal y confidencialidad legal.',
      h1: 'Política de Privacidad'
    },
    vi: {
      title: 'Chính Sách Bảo Mật - Công Ty Luật Daniel Albert',
      description: 'Chính sách bảo mật của Công Ty Luật Daniel Albert. Tìm hiểu cách chúng tôi bảo vệ thông tin cá nhân và tính bảo mật pháp lý.',
      h1: 'Chính Sách Bảo Mật'
    }
  },

  '/terms-of-use': {
    en: {
      title: 'Terms of Use - Daniel Albert Law Firm',
      description: 'Terms of use for Daniel Albert Law Firm website. Legal terms and conditions for using our services and website.',
      h1: 'Terms of Use'
    },
    es: {
      title: 'Términos de Uso - Firma Legal Daniel Albert',
      description: 'Términos de uso del sitio web de la Firma Legal Daniel Albert. Términos y condiciones legales para usar nuestros servicios.',
      h1: 'Términos de Uso'
    },
    vi: {
      title: 'Điều Khoản Sử Dụng - Công Ty Luật Daniel Albert',
      description: 'Điều khoản sử dụng cho trang web Công Ty Luật Daniel Albert. Điều khoản và điều kiện pháp lý để sử dụng dịch vụ.',
      h1: 'Điều Khoản Sử Dụng'
    }
  }
};

/**
 * Get comprehensive SEO data with URL-based fallback
 */
export function getComprehensiveSEOData(
  pathname: string,
  language: 'en' | 'es' | 'vi' = 'en'
): PageSEOData {
  const normalized = pathname.replace(/\/$/, '') || '/';
  const data = comprehensiveSEOData[normalized]?.[language];
  
  if (data) return data;

  // Dynamic fallback based on URL structure
  const slug = normalized.split('/').filter(Boolean).pop() || 'home';
  const toTitle = (s: string) => s.replace(/[-_]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  const baseTitle = toTitle(slug);

  const templates = {
    en: {
      title: `${baseTitle} | Daniel Albert Law Firm Houston`,
      description: `${baseTitle} legal services in Houston, TX. Experienced representation and guidance. Contact us at (832) 930-3059 for consultation.`,
      h1: baseTitle
    },
    es: {
      title: `${baseTitle} | Firma Legal Daniel Albert Houston`,
      description: `Servicios legales de ${baseTitle} en Houston, TX. Representación y orientación experta. Contáctenos al (832) 356-7254.`,
      h1: baseTitle
    },
    vi: {
      title: `${baseTitle} | Công Ty Luật Daniel Albert Houston`,
      description: `Dịch vụ pháp lý ${baseTitle} tại Houston, TX. Đại diện và hướng dẫn chuyên môn. Liên hệ (832) 987-6543.`,
      h1: baseTitle
    }
  };

  return templates[language];
}
